/**
 * Pluggable fabric region estimator.
 * TODO: swap implementation for TensorFlow Lite / MediaPipe segmentation / custom ONNX model.
 *
 * @typedef {import('../types').FabricRegionMetrics} FabricRegionMetrics
 */

/**
 * @abstract
 */
export class FabricDetector {
  /**
   * @param {ImageData} imageData RGBA full frame (any size)
   * @returns {Promise<FabricRegionMetrics>}
   */
  // eslint-disable-next-line no-unused-vars
  async detectFromImageData(imageData) {
    throw new Error('FabricDetector.detectFromImageData must be implemented');
  }
}
